import React, { useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import { useUser } from '../../context/UserContext';
import { useTenant } from '../../context/TenantContext';
import { addQuestionFollowUp } from '../../services/questionsService';
import './QnAFollowUpForm.css';

function QnAFollowUpForm({ questionId, onSubmitted }) {
  const [text, setText] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { user } = useUser();
  const { tenantId } = useTenant();

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!text.trim() || !user || !tenantId) {
      setError('Vprašanje ne sme biti prazno.');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      await addQuestionFollowUp(tenantId, questionId, { text: text.trim(), user });
      setText('');
      if (onSubmitted) {
        onSubmitted();
      }
    } catch (err) {
      console.error('[qna] Failed to add follow-up', err);
      setError('Pošiljanje dodatnega vprašanja ni uspelo. Poskusite znova.');
    } finally {
      setSubmitting(false);
    }
  };

  const content = (
    <>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label className="visually-hidden">Dodatno vprašanje</Form.Label>
          <Form.Control
            as="textarea"
            rows={4}
            value={text}
            onChange={(event) => setText(event.target.value)}
            placeholder="Postavite dodatno vprašanje…"
            required
          />
        </Form.Group>
        <Button variant="outline-primary" type="submit" disabled={submitting}>
          Pošlji dodatno vprašanje
        </Button>
      </Form>
    </>
  );

  return (
    <div className="qna-followup-form platform-content-detail-card">
      <div className="platform-content-detail-card__header">
        <h2 className="platform-content-detail-card__title">Dodatno vprašanje</h2>
      </div>
      <div className="qna-followup-form__body">{content}</div>
    </div>
  );
}

export default QnAFollowUpForm;
